import React, { useState } from "react";
import { Button, Input, Modal, Typography } from "antd";
import { sellBoostFetch } from "../../utlifyFunction";
import { toast } from "react-toastify";
const { TextArea } = Input;

const { Paragraph } = Typography;
export default function FeedbackModal({
	isFeedbackModalOpen,
	setIsFeedbackModalOpen,
    setVisible
}) {
	const [reviewText, setReviewText] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const handleSubmitFeedback = async () => {
        setIsLoading(true)
		const data = await sellBoostFetch("POST", "/user/review", {
			comment: reviewText,
			rating: isFeedbackModalOpen,
		});
		if (data?.status === 200) {
			toast.success("Thanks for review");
			setIsFeedbackModalOpen(false);
            setVisible(false)
		}
        setIsLoading(false)
	};
	return (
		<Modal
			title="We value your feedback! 💬"
			open={isFeedbackModalOpen}
			onCancel={() => setIsFeedbackModalOpen(false)}
			footer={[
				<Button
					loading={isLoading}
					key="cancel"
					onClick={() => setIsFeedbackModalOpen(false)}
					style={{ borderRadius: "8px" }}
				>
					Cancel
				</Button>,
				<Button
					key="submit"
					loading={isLoading}
					type="primary"
					onClick={handleSubmitFeedback}
					disabled={!reviewText.trim()}
					style={{
						background: "linear-gradient(90deg, #6D5BBA, #8D58BF)",
						border: "none",
						borderRadius: "8px",
						fontWeight: 500,
					}}
				>
					Submit Feedback
				</Button>,
			]}
		>
			<Paragraph style={{ color: "#333", fontSize: "14px" }}>
				We're sorry to hear that your experience wasn't great. Please share your
				feedback to help us improve.
			</Paragraph>
			<TextArea
				rows={4}
				placeholder="Write your feedback here..."
				value={reviewText}
				onChange={(e) => setReviewText(e.target.value)}
				style={{
					borderRadius: "8px",
					borderColor: "#D9D9D9",
					marginTop: "8px",
					padding: "10px",
				}}
			/>
		</Modal>
	);
}
